import { SavedSearchesResponse } from "../types";
import { getHeaders } from "../utils/getHeaders";

const getSavedSearches = async (
  url: string,
  isToUseAuthZero: boolean,
  authToken?: string,
  token?: string
): Promise<SavedSearchesResponse> => {
  const headers = getHeaders(authToken, isToUseAuthZero, token);

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  return await res.json();
};

export default getSavedSearches;
